import ApiHandler from "./ApiHandler";

const OAuthClient = {
  getAccept: async (query) => await ApiHandler.i.auth().get(`/oauth/client/accept?${query.toString()}`),
  getAccepted: async (query) => await ApiHandler.i.auth().get(`/oauth/client/accepted?${query.toString()}`),
  getOne: async (clientId) => await ApiHandler.i.auth().get(`/oauth/client/${clientId}`),
};

export default OAuthClient;